export default __webpack_public_path__ + "static/measuring-5c4c84074e709bd0c2a2e5b6d5cc5738.png";